import React, { useEffect, useState } from "react";
import { Spin } from "antd";
import { useTheme } from "../../utils/ThemeContext";
import DEATH_API from "../../apis/death.api";

const headers = [
  "Institution",
  "Account Name",
  "Account No.",
  "Balance",
  "Status",
];

const PortfolioBalancesTable = () => {
  const { theme } = useTheme();
  const [loading, setLoading] = useState(false);
  const [bankDetails, setBankDetails] = useState([]);

  const getBankDetails = async () => {
    try {
      setLoading(true);
      const response = await DEATH_API.getBankDetails();
      if (response && response.data) {
        const allAccount = response.data.filter((item) => {
          return item.planModule === "Investment Portfolio";
        });
        setBankDetails(allAccount);
      }
    } catch (error) {
      console.error("Error fetching bank details:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getBankDetails();
  }, []);

  return (
    <div style={{position: "relative",}}>
        <div
          style={{
            backgroundColor: theme === "dark" ? "#232323" : "white",
          }}>
          <h3
            style={{
              color: theme === "light" ? "#232323" : "white",
            }}>
            Portfolio Balances
          </h3>
          <div
            style={{
              backgroundColor: theme === "dark" ? "#232323" : "white",
            }}
            className="main-dashboad-table-container">
            <div className="table-wrapper">
              <table className="custom-table">
                <thead
                  style={{
                    backgroundColor: theme === "dark" ? "#232323" : "white",
                  }}>
                  <tr
                    style={{
                      fontWeight: "700",
                    }}>
                    {headers.map((header, index) => (
                      <th
                        style={{
                          fontWeight: "700",
                          color: theme === "dark" ? "#ffffff" : "#232323",
                          backgroundColor:
                            theme === "dark" ? "#232323" : "#ffffff",
                        }}
                        key={index}>
                        {header}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody
                  style={{
                    backgroundColor: theme === "dark" ? "#232323" : "white",
                  }}>
                  {bankDetails && bankDetails.length > 0 && !loading ? (
                    bankDetails.map((detail, rowIndex) => (
                      <tr key={rowIndex}>
                        <td
                          style={{
                            color: theme === "light" ? "#232323" : "white",
                          }}>
                          {detail.bankName}
                        </td>
                        <td
                          style={{
                            color: theme === "light" ? "#232323" : "white",
                          }}>
                          {detail.accountName}
                        </td>
                        <td
                          style={{
                            color: theme === "light" ? "#232323" : "white",
                          }}>
                          ****{detail.mask}
                        </td>
                        <td
                          style={{
                            color: theme === "light" ? "#232323" : "white",
                          }}>
                          ${detail.balance ? parseFloat(detail.balance).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "N?A"}
                        </td>
                        {/* // color: theme === "light" ? "#232323" : "white", */}
                        <td
                          style={{
                            color:
                              detail.status === "Add New Account"
                                ? theme === "light"
                                  ? "#2a3ddf"
                                  : "#2a3ddf"
                                : detail.status === "Exist in Plan"
                                ? theme === "light"
                                  ? "red"
                                  : "red"
                                : detail.status === "Added to Plan"
                                ? theme === "light"
                                  ? "#232323"
                                  : "#ffffff"
                                : "",
                          }}>
                          {detail.status === "Add New Account"
                            ? "New Account"
                            : detail.status === "Exist in Plan"
                            ? "We found a match"
                            : detail.status}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        style={{
                          color: theme === "light" ? "#232323" : "white",
                          textAlign: "center",
                        }}>
                        {loading ? "Loading..." : "No data available"}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      {loading ? (
        <div style={{ marginTop: "12px", display: "flex", justifyContent: "center", alignItems: "center", minHeight: "64px", borderRadius: "12px", border: "1px solid rgba(74, 98, 255, 0.35)", background: "linear-gradient(135deg, rgba(42, 61, 163, 0.16), rgba(42, 61, 163, 0.06))", boxShadow: "inset 0 1px 0 rgba(255,255,255,0.14)" }}>
          <Spin size="large" />
        </div>
      ) : null}
    </div>
  );
};

export default PortfolioBalancesTable;
